import React, { Component } from "react";
import { observer } from "mobx-react";
import { Web3Store } from "../stores/web3Store";
import { RootStore } from "../stores/rootStore";
import { RouteComponentProps, withRouter } from "react-router-dom";
import logger from "../logger";
import "../styles/IPLPublish.less";
import { ILicensedNFT, IMythServerResponse, IPagination } from "../bean/ResponseBean";
import { LicensedNFTStatus, LicensingType, LicensingRegion, MythServerResultCode } from "../constant/CommonConstant";
import { Collapse, Button, Form, Input, Radio, Checkbox, Modal } from "antd";
import type { RadioChangeEvent } from "antd";
import { PlayCircleFilled, InfoCircleOutlined, CheckCircleFilled } from "@ant-design/icons";
import { getRoutePath, MythRouteId } from "../router-config";
import { IPLInfo } from "../bean/RequestBean";
import MythImage from "../components/MythImage";
import EthSvg from "../components/connectWalletModal/ethSvg";
import IPL3DModel from "../components/IPL3DModel";
import { PageLoader } from "../components/pageLoader";

const { Scrollbars } = require("react-custom-scrollbars");

interface IProps extends RouteComponentProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}
interface IStates {
    licenseList: ILicensedNFT[],
    totalNum: number,
    totalPage: number,
    pageNum: number,
    loading: boolean,
    selectedIPId: number,
    selectedIPLLicenseTokenId: string,
    price: number,
    totalSupply: number,
    totalPrice: number,
    licensingPeriod: number,
    selectedContent: number[],
    licenseType: number,
    licenseNum: number,
    licenseRegion: number,
    currentStep: number
    searchStatus: number[],
    previewWidth: number,
    IPL3DCollectionName: string,
    IPL3DImageUrl: string,
    IPL3DImageReCreate: boolean,
    isPublishLoading: boolean,
}
@observer
class IPLPublish extends Component<IProps, IStates> {
    private firstRequest: boolean = true;
    private pageSize: number = 16;
    constructor(props: IProps, state: IStates) {
        super(props);
        this.state = {
            licenseList: [],
            totalNum: 0,
            totalPage: 1,
            pageNum: 1,
            loading: true,
            selectedIPId: -1,
            selectedIPLLicenseTokenId: "",
            price: 1,
            totalSupply: 10,
            totalPrice: 10,
            licensingPeriod: 180,
            selectedContent: [],
            licenseType: LicensingType.GENERAL,
            licenseNum: 1000,
            licenseRegion: LicensingRegion.REGION,
            currentStep: 0,
            IPL3DCollectionName: "",
            IPL3DImageUrl: "",
            IPL3DImageReCreate: false,
            isPublishLoading: false,
            searchStatus: [/*LicensedNFTStatus.UNLICENSED.valueOf(),*/LicensedNFTStatus.UNISSUED.valueOf()/*,LicensedNFTStatus.ISSUED.valueOf(),
                LicensedNFTStatus.PENDING.valueOf(),LicensedNFTStatus.REJECT.valueOf(),LicensedNFTStatus.REMOVED.valueOf()*/],
            previewWidth: 0
        }
    }

    getLicensedList = async () => {
        const { web3Store } = this.props;
        const { pageNum, licenseList, searchStatus } = this.state;
        try {
            if (web3Store.mythServerApi && web3Store.account) {
                const result: IMythServerResponse<IPagination<ILicensedNFT>> = await web3Store.mythServerApi.getMyIPLs(searchStatus, web3Store.account, pageNum, this.pageSize);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.firstRequest && (this.firstRequest = false);
                        const list = pageNum === 1 ? [] : licenseList;
                        this.setState({
                            licenseList: list.concat(data.dataList),
                            totalNum: data.totalNum,
                            totalPage: data.totalPage,
                            loading: false
                        });
                    }
                }
            }
        } catch (ex: any) {
            logger.error(ex);
        }
    };

    private stepItems: any[] = [{ title: "选择一个NFT", link: "#nft" }, { title: "授权和发行方案", link: "#license" }, { title: "发行IPLNFT", link: "#publish" }];

    renderStep = (item: any, i: number) => {
        const { currentStep } = this.state;
        const finishStep = currentStep > i;
        return <div key={i} className={`step-item ${finishStep ? "checked-step" : ""}`}>
            {finishStep ? <CheckCircleFilled onClick={() => this.toStep(item.link)} className="step-finished" /> : <div onClick={() => this.toStep(item.link)} className={`step-cont ${currentStep === i ? "current" : ""}`}>{i + 1}</div>}
            <div className="text-center title">{item.title}</div>
        </div>
    }
    toStep = (link: string) => {
        window.location.href = link;
    }
    toLicense = () => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.LicensePage)
        })
    }
    onScroll = (e: any) => {
        const { pageNum, totalPage, loading } = this.state;
        if (pageNum === totalPage || loading) { return false }
        if (e.target.scrollTop + e.target.offsetHeight > e.target.scrollHeight - 10) {
            this.setState({
                loading: true,
                pageNum: pageNum + 1
            }, this.getLicensedList)
        }
    }
    selectIP = (ip: ILicensedNFT) => {
        this.setState({
            selectedIPId: ip.ipId,
            currentStep: 1,
            IPL3DImageUrl: ip.licensedNFTImage,
            IPL3DImageReCreate: true,
            IPL3DCollectionName: ip.licenseCollectionName,
            selectedIPLLicenseTokenId: ip.licensedNFTokenId
        });
    }
    renderIPItem = (item: ILicensedNFT) => {
        const { selectedIPId } = this.state;
        return <div className={`ip-item ${item.ipId === selectedIPId ? "selected" : ""}`} key={item.ipId} onClick={() => this.selectIP(item)}>
            <MythImage src={item.licensedNFTImage} />
        </div>
    }
    chooseSupply = (num: number) => {
        const { price } = this.state
        this.setState({
            totalSupply: num,
            totalPrice:  Number((price * num).toFixed(5))
        })
    }
    changePrice = (event: any) => {
        const { price, totalSupply } = this.state;
        let value = event.target.value;
        const regExp = /^[0-9]\d*[.]?\d{0,5}$/;
        if (value === '') {
            value = '0';
        }
        if (!regExp.test(value)) {
            return;
        }
        const num = Number.parseInt(value);
        // if (num > remainSellTokensNumber) {
        //     return;
        // }
        this.setState({
            price: value,
            totalPrice: Number((value * totalSupply).toFixed(5))
        })
    }
    changeNum = (event: any) => {
        let value = event.target.value;
        const regExp = /^[0-9]\d*$/;
        if (value === '') {
            value = '0';
        }
        if (!regExp.test(value)) {
            return;
        }
        const num = Number.parseInt(value);
        this.setState({
            licenseNum: num
        })
    }
    onChangeLicensingPeriod = ({ target: { value } }: RadioChangeEvent) => {
        this.setState({ licensingPeriod: value });
    };
    onChangeType = ({ target: { value } }: RadioChangeEvent) => {
        this.setState({ licenseType: value });
    };
    onChangeContent = (val: any[]) => {
        this.setState({
            selectedContent: val,
            currentStep: 2
        })
    }
    publishIP = async () => {
        const { totalSupply, totalPrice, licensingPeriod, licenseType, selectedContent, licenseRegion, licenseNum, price, selectedIPId } = this.state;
        const { web3Store } = this.props;
        try {
            if (selectedIPId < 0) {
                this.toStep(this.stepItems[0].link)
                return;
            }
            if (licenseType < 0 || selectedContent.length === 0) {
                this.toStep(this.stepItems[1].link)
                return;
            }
            if (web3Store.mythServerApi && web3Store.account) {
                this.setState({
                    isPublishLoading: true
                })
                let iplInfo: IPLInfo
                iplInfo = {
                    licensingPeriod: licensingPeriod,
                    ipId: selectedIPId,
                    licensingContent: JSON.stringify(selectedContent),
                    licensingNum: licenseNum,
                    licensingRegion: licenseRegion,
                    licensingType: licenseType,
                    price: price,
                    supply: totalSupply
                }
                const result: IMythServerResponse<Boolean> = await web3Store.mythServerApi.addIPL(web3Store.account, iplInfo);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    Modal.success({
                        content: 'Publish success',
                        onOk: args => {
                            window.location.reload()
                        }
                    });
                }
                this.setState({
                    isPublishLoading: false
                })
            }
        } catch (ex: any) {
            this.setState({
                isPublishLoading: false
            })
            logger.error(ex);
        }

    }
    private resizeObserver: any;
    setPreviewWidth = () => {
        const self = this;
        const ipPreview = document.getElementById("ipPreview");
        this.resizeObserver = new ResizeObserver(function (entries) {
            entries.forEach((item, index) => {
                const ipPreviewClientWidth = ipPreview?.clientWidth
                self.setState({
                    previewWidth: ipPreviewClientWidth || 0
                })
            })
        })
        if (ipPreview !== null) {
            this.resizeObserver.observe(ipPreview)
        }

    }
    componentDidMount(): void {
        this.setPreviewWidth();
    }
    componentWillUnmount(): void {
        const ipPreview = document.getElementById("ipPreview");
        this.resizeObserver.unobserve(ipPreview);
    }
    private licenseContent: any[] = [
        { content: "Derivatives licensing", serverId: 0, tip: "Selecting this option means that you license a third party to use your NFT IP to create derivative works and use them for packaging, physical merchandise, etc." },
        { content: "Gift licensing", serverId: 1, tip: 'Selecting this options means that your NFT IP can be used for product giveaways, which are required to be "not for sale"' },
        { content: "Marketing licensing", serverId: 2, tip: "Selecting this option means that your NFT IP can be used for marketing communications" },
        { content: "IP adaption rights", serverId: 3, tip: "Selecting this option means that your NFT IP can be adapted for film, TV, animation, games, etc." },
        { content: "Offline shop licensing", serverId: 4, tip: "Choosing this option means your NFT IP can be used in themed restaurants, themed amusement parks, and other offline locations." },
        { content: "Digital virtual licensing", serverId: 5, tip: "Selecting this option means that your NFT IP can be used for gaming marketing and events." }
    ]


    render() {
        const { licenseList, price, totalSupply, totalPrice, licensingPeriod, selectedContent,
            licenseRegion, licenseType, licenseNum, previewWidth, IPL3DCollectionName, IPL3DImageUrl, IPL3DImageReCreate,
            selectedIPLLicenseTokenId, isPublishLoading, loading } = this.state;
        const { Panel } = Collapse;
        const { Item } = Form;
        if (this.firstRequest) {
            this.getLicensedList()
        }

        return <div className="ipl-launch-container">
            {/*<div className="license-step flex-row space-between">
                {this.stepItems.map((item,i)=>(
                    this.renderStep(item,i)
                ))}
            </div>*/}
            <Collapse defaultActiveKey={['1', '2', '3']} expandIcon={({ isActive }) => <PlayCircleFilled className="panel-arrow" rotate={isActive ? -90 : 90} />} expandIconPosition="end" ghost >
                <Panel header={<span className="list-publish-title" id="nft">Select an NFT</span>} key="1">
                    <div className="myth-panel preview-container flex-row">
                        <div id="ipPreview" className="ip-preview">
                            {
                                IPL3DCollectionName.length > 0 && selectedIPLLicenseTokenId.length > 0 ?
                                    <IPL3DModel collectionName={IPL3DCollectionName} nftTokenId={`#${selectedIPLLicenseTokenId}`} nftImageUrl={IPL3DImageUrl} width={previewWidth} height={previewWidth} reCreate={IPL3DImageReCreate} /> :
                                    ""
                            }
                        </div>
                        <div className="ipl-content flex-col">
                            <div className="ipl-content-title">Select an NFT and generate an IP-Licensing Card</div>
                            {!this.firstRequest && licenseList.length === 0 ?
                                <div className="ipl-empty">
                                    <Button className="myth-button" onClick={this.toLicense}>License your NFT</Button>
                                </div>
                                : <div className="ipl-list">
                                    <Scrollbars style={{ width: "100%", height: "100%" }} onScroll={this.onScroll}>
                                        {loading ?
                                            <PageLoader /> :
                                            <div id="ipList" className="flex-row ip-list">
                                                {licenseList.map((item, i) => (
                                                    this.renderIPItem(item)
                                                ))}
                                            </div>
                                        }
                                    </Scrollbars>
                                </div>}
                        </div>
                    </div>
                </Panel>
                <Panel header={<span className="list-publish-title" id="license">Licensing Program</span>} key="2">
                    <div className="myth-panel">
                        <Form className="authorize-form" layout="vertical">
                            <Item name="type" label="Type of licensing" initialValue={licenseType}>
                                <Radio.Group onChange={this.onChangeType} value={licenseType}>
                                    <Radio defaultChecked value={LicensingType.GENERAL}> General license </Radio>
                                    <Radio disabled value={LicensingType.EXCLUSIVE}> Exclusive license </Radio>
                                </Radio.Group>
                            </Item>
                            <Item label="Content of licensing" >
                                <Checkbox.Group onChange={this.onChangeContent} value={selectedContent}>
                                    {this.licenseContent.map((item, i) => (
                                        <div key={i} className="check-item">
                                            <Checkbox value={item.serverId}>{item.content}</Checkbox> <span className="tip"><InfoCircleOutlined />{item.tip}</span>
                                        </div>))}
                                </Checkbox.Group>
                            </Item>
                            <Item name="licensingNumber" label="Number of licensings">
                                <>
                                    <label>Number of licensings</label>
                                    <Item name="licenseNumber" initialValue={licenseNum} noStyle ><Input value={licenseNum} className="license-number-input" readOnly /></Item>
                                    <span className="tip"><InfoCircleOutlined />In the standard version of the IP-licensing card, the licensee cannot apply this IP to more than 1000 copies of the product.</span>
                                </>
                            </Item>
                            <Item name="region" label="Licensing region" initialValue={licenseRegion}>
                                <Radio defaultChecked value={licenseRegion}> Worldwide </Radio>
                            </Item>
                            <Item name="period" label="Licensing period" initialValue={licensingPeriod}>
                                <Radio.Group onChange={this.onChangeLicensingPeriod} value={licensingPeriod}>
                                    <Radio value={180}> 180 Day </Radio>
                                    <Radio value={360}> 360 Day </Radio></Radio.Group>
                            </Item>
                        </Form>
                    </div>
                </Panel>
                <Panel header={<span id="publish" className="list-publish-title">Launching Program</span>} key="3">
                    <div className="myth-panel text-center">
                        <div className="flex-row space-around license-project">
                            <div>
                                <p className="label"><span>IP Licensing Card Price x {price}</span> <EthSvg size={24} /></p>
                                <Input placeholder="Total Supply" value={price} onChange={this.changePrice} className="total-input" />
                            </div>
                            <div>
                                <p className="label">Total Supply</p>
                                <div>{[10, 50, 100].map(item => (<span key={item} className={`supply-choice ${totalSupply === item ? "choose" : ""}`} onClick={() => this.chooseSupply(item)}>{item}</span>))}</div>
                            </div>
                            <div>
                                Expected total revenue ≈{totalPrice} <EthSvg size={24} />
                            </div>
                        </div>
                        <Button className="myth-button" loading={isPublishLoading} onClick={() => this.publishIP()}>Complete and launch</Button>
                    </div>
                </Panel>
            </Collapse>
        </div>
    }
}
export default withRouter(IPLPublish);
